<button type="button" class="btn btn-primary me-2" [disabled]="disabled">Button</button>
<button type="button" class="btn btn-warning" (click)="disabled = !disabled">Enable/Disable</button>

